import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const ActualizarItemFormato = () => {
  const api = useApi();
  const mutate = async (params) => {
    const fetchData = {
      ...params,
    };
    const id = params.feit_id;
    delete fetchData.id;
    const { data } = await api.put(`/formatos-etiquetas-item/${id}`, fetchData, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data;
  };

  const mutation = useMutation(mutate);

  return {
    actualizarFormatoItem: mutation.mutate,
  };
};
